import { pipe } from 'lodash/fp';

import {
  audienceTypeRequestInterceptor,
  audienceTypeResponseInterceptor,
} from './audienceType.interceptors';

export const requestInterceptors = pipe(audienceTypeRequestInterceptor);
export const responseInterceptors = pipe(audienceTypeResponseInterceptor);
